<template>
  <div>
    <tool-bar :title="toolbarTitle"></tool-bar>
    <loading :loading="loading"></loading>
    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false"
    ></error-alert-item>

    <activity-redirect-item
      :loan-tasks="tasks"
      :current-loan-task="currentTaskName"
      :is-loan-task="true"
      :redirect-activity="redirectActivity"
    ></activity-redirect-item>

    <single-message-dialog
      :message="singleMessageDialogMessage"
      :show="showSingleMessageDialog"
      button-text="Go to Home Page"
      @onContinue="onGoToHomePage"
    ></single-message-dialog>

    <stage-comment-item :show="!showRefreshItem && !showIframe"></stage-comment-item>

    <refresh-item
      :show="showRefreshItem"
      @onRefresh="fetchInitialData"
    ></refresh-item>

    <div v-if="lenderPlatformMessage"
         class="margin_top_20 margin-left-10 margin-right-10">
      <weex-text
        class="font-size-sm-base text-color-black"
        v-html="lenderPlatformMessage"
      ></weex-text>
    </div>

    <div v-show="showIframe">
      <iframe
          :src="iframeLink"
          class="fit-iframe"
          id="kycIframe"
          :style="iframeStyle()"
      ></iframe>

      <weex-text class="dismiss-iframe">
        <span
            @click="dismissIframe"
            class="item-iframe-dismiss-link">Click here</span>
        <span
            class="font-size-base"> to go back to loan application when KYC is successful.
        </span>
      </weex-text>
    </div>

    <div class="margin_top_40" v-show="showUI">
      <kyc-options-item
        ref="kycOptionItem"
        :show="showKycOptionsItem"
        @continueEKYC="continueEKYC"
        @continueManualKyc="continueManualKyc"
      ></kyc-options-item>

      <kyc-s-d-k-item
        :show="showKycSDKItem"
        :sdk-details="kycSDKDetailsConfig"
        @onGoToHomePage="onGoToHomePage"
        @onCompleted="getNextTask"
      ></kyc-s-d-k-item>

      <kyc-osv-item
        v-if="showKycOsvItem"
        :kyc-osv-details-config="kycOsvDetailsConfig"
        :okyc-data-config="okycDataConfig"
        :is-retailer-kyc-config="isRetailerKycConfig"
        @osvCompleted="getNextTask"
      ></kyc-osv-item>
    </div>
  </div>
</template>
<script>

import ToolBar from "../../layout/ToolBar";
import Loading from "../../layout/Loading";
import ActivityRedirectItem from "../../layout/ActivityRedirectItem";
import ErrorAlertItem from "../../layout/ErrorAlertItem";
import KycOsvItem from "../../layout/KycOsvItem";
import KycSDKItem from "../../layout/KycSDKItem";
import KycOptionsItem from "../../layout/KycOptionsItem";
import StageCommentItem from "../../layout/StageCommentItem";
import AlertService from "../../core/alert/AlertService";
import LoanScopeDataHolder from "../../../data/model/LoanScopeDataHolder";
import PrefManager from "../../../data/model/PrefManager";
import EzUtils from "../../../utils/EzUtils";
import LoanTasksUtility from "../../../utils/LoanTasksUtility";
import ActivityNavigator, { Activities } from "../../../utils/ActivityNavigator";
import { MessageConstants } from "../../../utils/MessageConstantUtil";
import LoanTasksActivityNavigator from "../../../utils/LoanTasksActivityNavigator";
import SingleMessageDialog from "../../dialogs/SingleMessageDialog";
import RefreshItem from "../../layout/RefreshItem";
import DataSource from "../../../data/DataSource";
import storageUtil from "../../../utils/StorageUtil";
import {Constants} from "@/components/Constants";
import AttributeUtil, { AttributeDetails } from '../../../utils/AttributeUtil';
import { EntityType } from '../../../utils/EntityType';

const OSV = "OSV";
const SDK = "SDK";

export default {
  name: "KycActivity",
  components: {
    RefreshItem,
    ActivityRedirectItem,
    ErrorAlertItem,
    Loading,
    ToolBar,
    KycOsvItem,
    KycOptionsItem,
    SingleMessageDialog,
    StageCommentItem,
    KycSDKItem
  },
  data: () => ({
    showUI: false,
    stageConfigData: {},
    showKycOptionsItem: false,
    showKycOsvItem: false,
    showKycSDKItem: false,
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    showSingleMessageDialog: false,
    showRefreshItem: false,
    singleMessageDialogMessage: "",
    lenderPlatformMessage: "",
    showIframe: false,
    iframeLink: ""
  }),

  methods: {
    showToast(message) {
      AlertService.showToast(message);
    },

    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    continueManualKyc() {
      this.createOrUpdateSelectedKycAttributeIfRequired("OSV")
      .then(attributeSaved => {
        if(attributeSaved) {
          this.showKycOptionsItem = false;
          this.showKycOsvItem = true;
        }
      });
    },

    continueEKYC() {
      this.createOrUpdateSelectedKycAttributeIfRequired("SDK")
      .then(attributeSaved => {
        if(attributeSaved) {
            this.loading = true;
            DataSource.sendLoanStageDetails({
              loanAccountNumber: LoanScopeDataHolder.getLoanAccountNumber(),
              taskMode: SDK,
              taskName: Activities.KYC
            })
            .then(res => {
              this.loading = false;
              if (res.errorOccurred) {
                this.showError(res.data)
              } else {
                this.showKycOptionsItem = false;
                this.showKycSDKItem = true;
              }
            })
          }
      });
     
    },

    getNextTask() {
      this.loading = true;
      LoanTasksActivityNavigator.getNextTask(this.tasks)
        .then(res => {
          this.loading = false;
          if (res.errorOccurred) {
            this.showError(res.data);
          }
        })
    },

    onGoToHomePage() {
      ActivityNavigator.navigateTo(Activities.LOAN_DETAILS);
    },

    fetchInitialData() {
      this.showRefreshItem = false;
      this.loading = true;
      LoanTasksUtility.getLoanStageConfigData(LoanScopeDataHolder.getLoanId(), this.currentTaskName)
        .then(stageConfigDataRes => {
          this.loading = false;
          if (stageConfigDataRes.errorOccurred) {
            this.showError(stageConfigDataRes.data);
            this.showRefreshItem = true;
          } else {
            const stageConfigData = stageConfigDataRes.data ? stageConfigDataRes.data : {};
            if (stageConfigData.completeOnLenderPlatform) {
              const lenderPlatformDetails = stageConfigData.lenderPlatformDetails;

              if (lenderPlatformDetails) {
                if (EzUtils.areEqualString(
                    "iframe",
                    lenderPlatformDetails.urlOpeningMode,
                    true
                )) {
                  if (lenderPlatformDetails.url) {
                    this.iframeLink = lenderPlatformDetails.url;
                    this.showIframe = true;

                    const kycIframe = document.getElementById("kycIframe");
                    if (kycIframe) {
                      const outerRef = this;
                      this.loading = true;
                      kycIframe.onload = function () {
                        outerRef.loading = false;
                      };
                      kycIframe.onerror = function () {
                        outerRef.loading = false;
                      };
                    }
                  }
                } else if (lenderPlatformDetails.message) {
                  this.lenderPlatformMessage = lenderPlatformDetails.message;
                }
              }
            } else {
              if (!stageConfigData.kycOptions
                || stageConfigData.kycOptions.length === 0
                || (stageConfigData.kycOptions.includes(OSV)
                  && (!stageConfigData.kycOSVDetailsDto
                    || EzUtils.isEmpty(stageConfigData.kycOSVDetailsDto.allowedAddressProofs)
                    || EzUtils.isEmpty(stageConfigData.kycOSVDetailsDto.allowedIdProofs)
                    || EzUtils.isEmpty(stageConfigData.kycOSVDetailsDto.source)
                  ))
                || (stageConfigData.kycOptions.includes(SDK)
                  && (!stageConfigData.kycSDKDetailsDto
                    || EzUtils.isEmpty(stageConfigData.kycSDKDetailsDto.urnNumber)
                  ))
                || (!stageConfigData.allowedRoles || stageConfigData.allowedRoles.length === 0)
              ) {
                this.showToast(MessageConstants.CONFIG_DATA_INVALID)
              } else {
                if (!this.canContinueKycTask(stageConfigData)) {
                  return;
                }

                this.showUI = true;
                this.stageConfigData = stageConfigData;
                this.showKycOptionsItem = true;
                this.$refs.kycOptionItem.showKycOptionItem(stageConfigData.kycOptions);
              }
            }
          }
        })
    },

    canContinueKycTask(kycDetails) {
      let hasValidRole = false;
      let allowedRoles = "";

      kycDetails.allowedRoles.forEach(allowedRole => {
        allowedRoles = allowedRoles ? `${allowedRoles}, ${allowedRole}` : allowedRole;
        if (PrefManager.doesUserHasRole(allowedRole)) {
          hasValidRole = true;
        }
      });

      if (!hasValidRole) {
        this.singleMessageDialogMessage = `KYC needs to be done by ${allowedRoles}. Please contact support for any help.`;
        this.showSingleMessageDialog = true;
      }

      return hasValidRole;
    },

    dismissIframe() {
      this.onGoToHomePage();
    },

    iframeStyle() {
      const style = {};
      if (document && document.body && document.body.scrollHeight > 200) {
        const pageHeight = document.body.scrollHeight;
        style["max-height"] = pageHeight - 200 + "px";
      }

      return style;
    },

    createOrUpdateSelectedKycAttributeIfRequired(selectedKyc) {
      if(!this.stageConfigData.retailerKycConfig) {
        return new Promise(resolve => {
          this.loading = true;
          DataSource.createOrUpdateAttribute(
            AttributeUtil.getAttributeUpdateDto(
              EntityType.LOANS,
              LoanScopeDataHolder.getLoanId(),
              AttributeUtil.getSingleAttributeData(
                AttributeDetails.KYC_MODE_SELECTED.key,
                AttributeDetails.KYC_MODE_SELECTED.name,
                selectedKyc
              )
            )
          )
          .then(res => {
            this.loading = false;
            if (res.errorOccurred) {
              this.showError(res.data);
              resolve(false);
            } else {
              resolve(true);
            }
          })
        })
      } else {
        return new Promise(resolve => {
          resolve(true);
        });
      }

    },
  },

  mounted: function () {

    this.fetchInitialData();
  },

  computed: {
    kycOsvDetailsConfig() {
      return this.stageConfigData ? this.stageConfigData.kycOSVDetailsDto : {};
    },

    isRetailerKycConfig() {
      return this.stageConfigData ? this.stageConfigData.retailerKycConfig : false;
    },

    kycSDKDetailsConfig() {
      return this.stageConfigData ? this.stageConfigData.kycSDKDetailsDto : {};
    },

    okycDataConfig() {
      return this.stageConfigData ? this.stageConfigData.oKycDetails : {};
    },

    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.KYC, Activities.KYC_RETAILER];
    },

    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
        ? LoanScopeDataHolder.getCurrentLoanTask().name
        : "";
    },

    toolbarTitle() {
      const activityDescription = Activities.getActivityDescription(this.currentTaskName);
      return Activities.KYC_RETAILER === this.currentTaskName
      && EzUtils.areEqualString(
          Constants.FORM_60,
          LoanScopeDataHolder.getLoanCreationIdentifier(),
          true
      ) ? "Documents for Form-60" : (activityDescription ? activityDescription.title : "");
    },
  }
}
</script>

<style>
.fit-iframe {
  overflow:hidden;
  overflow-x:hidden;
  overflow-y:hidden;
  height:100%;
  width:100%;
  position:absolute;
  top:120px;
  left:0px;
  right:0px;
  bottom:60px;
  border:none;
}

.item-iframe-dismiss-link {
  font-size: 16px;
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}

.dismiss-iframe {
  padding-top: 10px;
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: #ddd;
  overflow:hidden;
  overflow-x:hidden;
  overflow-y:hidden;
  height:80px;
  width:100%;
  position:absolute;
  left:20px;
  right:20px;
  bottom:0px;
}

</style>

<style scoped src="../../../assets/style/base.css"></style>
